import Paragraph from '../typography/Paragraph'

import styles from './styles/Feature.css'
import Header from '../typography/Header'
import Link from '../misc/Link'
import classNames from 'classnames'
import * as analytics from 'lib/analytics'
import headerLvl from 'components/typography/styles/Header.css'

export const Feature = ({
  img = '',
  icon = null,
  alt = '',
  imgTop = false,
  imgClass = '',
  to = '',
  href = '',
  header,
  children,
  className,
  underline = true,
  onClick = null,
  ...rest
}) => {
  const onFeatureDropdownClick = e => {
    analytics.event({
      category: 'Feature Dropdown',
      action: header
    })
    if (onClick) onClick(e)
  }

  const renderIcon = centered => {
    if (icon) {
      return <span className={classNames(styles.iconWrapper, { [styles.centered]: centered })}>{icon}</span>
    }
    if (img) {
      return (
        <img
          className={classNames(styles.illo, { [styles.centered]: centered }, imgClass)}
          src={img}
          alt={alt || header}
        />
      )
    }
    return null
  }

  return (
    <Link
      to={to}
      href={href}
      {...rest}
      onClick={onFeatureDropdownClick}
      className={classNames({ [styles.onlyText]: !underline })}
    >
      {imgTop && renderIcon(true)}
      <div className={classNames(styles.feature, className)}>
        {!imgTop && renderIcon(false)}
        <div className={styles.content}>
          <Header className={classNames(imgTop ? styles.headerLarge : styles.header, headerLvl.h6)} level={3}>
            {header}
          </Header>
          {children && (
            <Paragraph light type='bodyLeft' className={imgTop ? styles.featureCopyLarge : styles.featureCopy}>
              {children}
            </Paragraph>
          )}
        </div>
      </div>
    </Link>
  )
}

export default Feature
